export default function ApproachSection() {
  return (
    <section className="relative bg-background-50 py-24 md:py-32 px-8 md:px-12">
      <div className="max-w-[1400px] mx-auto">
        <div className="lg:max-w-[65%]">
          <span className="text-xs uppercase tracking-[0.2em] text-primary-600 font-medium">
            Methodology
          </span>

          <div className="mt-8 space-y-2">
            <div className="flex items-center gap-4 flex-wrap">
              <span className="text-5xl md:text-6xl lg:text-[64px] font-light text-primary-500 leading-[1.1]">
                Clean
              </span>
              <div className="w-14 h-14 md:w-[60px] md:h-[60px] rounded-full overflow-hidden shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20architectural%20texture%20close%20up%20of%20natural%20stone%20surface%20with%20subtle%20veining%20in%20cream%20beige%20and%20sand%20tones%20soft%20organic%20patterns%20macro%20detail%20editorial%20photography&width=200&height=200&seq=analitikos-appr-01&orientation=squarish"
                  alt="Abstract warm-toned architectural texture with natural stone veining"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div>
              <span className="text-5xl md:text-6xl lg:text-[64px] font-light text-primary-500 leading-[1.1]">
                Architecture
              </span>
            </div>

            <div className="flex items-center gap-4 flex-wrap">
              <div className="w-14 h-14 md:w-[60px] md:h-[60px] rounded-full overflow-hidden shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20grid%20pattern%20in%20muted%20sage%20green%20tones%20with%20precise%20intersecting%20lines%20on%20light%20background%20clean%20technical%20aesthetic%20minimal%20design%20like%20architectural%20drafting%20paper%20texture&width=200&height=200&seq=analitikos-appr-02&orientation=squarish"
                  alt="Abstract geometric grid pattern in muted green tones"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-5xl md:text-6xl lg:text-[64px] font-light text-primary-500 leading-[1.1]">
                Performance
              </span>
              <div className="w-12 h-12 md:w-[50px] md:h-[50px] border-2 border-primary-400 rounded-lg grid grid-cols-2 grid-rows-2 gap-px p-1 shrink-0">
                <div className="bg-primary-400/40 rounded-sm"></div>
                <div className="bg-primary-400/20 rounded-sm"></div>
                <div className="bg-primary-400/20 rounded-sm"></div>
                <div className="bg-primary-400/40 rounded-sm"></div>
              </div>
            </div>
          </div>

          <div className="mt-20 max-w-2xl">
            <p className="text-lg text-foreground-600 leading-relaxed" style={{ maxWidth: '55ch' }}>
              Our engineering approach is built on the principles of clean architecture, ensuring every system we design
              is modular, testable, and adaptable to evolving requirements. We prioritize performance optimization at
              every layer, from foundational data structures to high-level interaction flows. Every decision is guided by
              user-centered design thinking, ensuring the systems we build are not only technically sound but also
              intuitive and effective for the people who rely on them.
            </p>
            <p className="mt-6 text-lg text-foreground-600 leading-relaxed" style={{ maxWidth: '55ch' }}>
              We follow modern software engineering practices that emphasize maintainability, long-term technical
              quality, and systematic improvement of development workflows. By adopting up-to-date engineering standards
              and continuously evolving our internal processes, we deliver systems that remain reliable and relevant
              well into the future.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-24 h-px bg-background-200/70 max-w-[1400px] mx-auto"></div>
    </section>
  );
}